import React from 'react';
import './styles/Body.css';
import Home from "./pages/Home";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Bio from "./pages/Bio";
import Resume from "./pages/Resume";
import Testimonials from "./pages/Testimonials";
import ContactMe from "./pages/ContactMe";
import Videos from "./pages/Videos";
import Album from "./pages/Album";
import bioData from '../information/Bio.json';
import resumeData from '../information/Resume.json';
import Admin from "../admin/Admin";
import Header from "./Header";
import BioEditorPro from "../admin/BioEditorPro";


const Body = () => {
    return (
        <div style={{ paddingBottom: "30px", minHeight: "100%"}}>
            <Router>
                <Header/>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/bio" element={<Bio bioData={bioData} />} />
                    <Route path="/resume" element={<Resume resumeData={resumeData}/>} />
                    <Route path="/testimonials" element={<Testimonials />} />
                    <Route path="/contact-me" element={<ContactMe />} />
                    <Route path="/videos-all" element={<Videos tittle={"All videos"}/>} />
                    <Route path="/videos-hunters" element={<Videos tittle={"Hunters videos"}/>} />
                    <Route path="/videos-jumpers" element={<Videos tittle={"Jumpers videos"}/>} />
                    <Route path="/videos-eq" element={<Videos tittle={"Eq videos"}/>} />
                    <Route path="/album" element={<Album/>} />
                    <Route path="/admin" element={<Admin/>} />
                    <Route path="/admin2" element={<BioEditorPro/>} />
                </Routes>
            </Router>
        </div>
    );
};

export default Body;
